import { useFormOptions } from '../../../hooks';
import { useProductFactorableFields } from '../../product/hooks';
import { useVehicleTypeOptions } from '../../configurationVehicleTypes/hooks';
import { usePremiumRateModes } from '../../../components/sharedComponents/pricing';

export default function useProductPricingFormOptions({ productId }) {
  const { premiumRateModeOptions: rateModeOptions, loading: rateModeOptionsLoading } = usePremiumRateModes();
  const { vehicleTypeOptions, loading: vehicleTypeOptionsLoading } = useVehicleTypeOptions();
  const { flattenedOptions: factorableFieldsOptions, loading: factorableFieldsOptionsLoading } =
    useProductFactorableFields({
      productId
    });

  const formOptions = useFormOptions({
    options: [
      { name: 'rateMode', options: rateModeOptions, loading: rateModeOptionsLoading },
      {
        name: 'vehicleTypes',
        options: vehicleTypeOptions,
        loading: vehicleTypeOptionsLoading
      },
      {
        name: 'factorableFields',
        options: factorableFieldsOptions,
        loading: factorableFieldsOptionsLoading
      },
      {
        name: 'stateMode',
        options: [
          { label: 'Include', value: 'include' },
          { label: 'Exclude', value: 'exclude' }
        ]
      }
    ]
  });

  return { formOptions };
}
